var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-page"},[_c('van-nav-bar',{attrs:{"z-index":"9","title":_vm.title,"border":false,"left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"agreement-content"},[_c('iframe',{attrs:{"src":'data:text/html;base64,' + _vm.base64Str,"frameborder":"0","width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }